/**
 *@param url ajax 访问连接
 *@param params 传输对象
 *@param ctx 外层对象传入
 *@param success 回调成功函数
 *@param error 回调错误处理
 *@param async 异步
 *@param name 图片上传name字段
 */
var site = {
    config: {
        reload: true,
        loadMore: true,
        error: true,
    },
    //当前访问服务器域名
    javaHttp: 'http://dev-api.yaduo.com/atourlife/',
    httpSever: 'http://dev-api.yaduo.com/atourlifeapp/',
    newHttpSever: 'http://test-api.at-our.cn/atourlife/',
//  imgUrl: "http://omwalulqk.bkt.clouddn.com/", //测试
//    javaHttp: 'http://api.yaduo.com/atourlife/',
//    httpSever: 'http://apps.yaduo.com/atourlifeapp/',
//    newHttpSever: 'http://apps.yaduo.com/atourlife/',
    //密钥
    aesKey: "uA1Nl4u/+4G4LBuT",
    ivStr: "ZH9NC3Y5K9D0M7QL",
    // imgUrl:"http://omwalulqk.bkt.clouddn.com/",//正式图片路径地址
    imgUrl: 'http://om89vvwsz.bkt.clouddn.com/',
    pageSize: 10,
    _get: function () {
        var arg = arguments;
        this.http('GET', arg, true);
    },
    _post: function () {
        var arg = arguments;
        this.http('POST', arg, true);
    },
    _put: function () {
        var arg = arguments;
        this.http('PUT', arg, true);
    },
    _delete: function () {
        var arg = arguments;
        this.http('DELETE', arg, true);
    },
    _upload: function () {
        var oData = new FormData(document.forms.namedItem(arg[1]));
        var arg = arguments;
        arg[1] = oData;
        this.http('POST', arg, false);
    },
    http: function (type, arg, processData) {
        var _http = "",
            path = "",
            arr = [];
        if (arg[0].indexOf('http') != 0) {
            _http = this.httpSever;
            path = arg[0];
        } else {
            var arr = arg[0].split('//');
            _http = arr[0] + '//' + arr[1];
            path = arr[2] ? '/' + arr[2] : ''
        }
        var param = {
            url: _http + path,
            params: arg[1],
            ctx: arg[2],
            success: arg[3],
            error: arg[4],
            type: arg[5],
            async: arg[6],
        };
        if (param.params.appVer == undefined) {
            param.params = this.requestJson(param.params);
        }
        if (param.type) {
            var service_name = path.match(/(\w+)\.cgi$/i);
            if (service_name && !service_name[1]) {
                console.log('加密 key 错误。');
                return false;
            }
            param.params = this._encode(service_name[1], param.params);
        }
        if (param.params.appVer == undefined) {
            param.params = this.requestJson(param.params);
        }
        param.processData = processData
        this._http(type, param);
    },
    _http: function (type, obj) {
        var resObj = this.setArguments(type, obj);
        var _this = this;
        $.ajax({
            type: type,
            url: resObj.url,
            data: resObj.params,
            timeout: 60000,
            dataType: 'json',
            async: resObj.async,
            processData: resObj.processData,
            beforeSend: function (xhr, settings) {
                if (_this.config.reload) {
                    $('#auour_loading').show();
                }
                //xhr.setRequestHeader("Authorization", "Bearer " + tokenInfo.access_token);
            },
            success: function (data) {
                if (_this.config.reload) {
                    setTimeout(function () {
                        $("#auour_loading").hide();
                    }, 500);
                }
                if (resObj.success && Object.prototype.toString.call(resObj.success) === '[object Function]')
                    resObj.success.apply(resObj.ctx, [data]);
                // if(data.retcode == 0) {
                // 	resObj.success.apply(resObj.ctx, [data]);
                // } else {
                // 	if(_this.config.error) {
                // 		toast.showToast(data.retmsg);
                // 	}
                // }
            },
            error: function (xhr, type) {
                if (_this.config.reload) {
                    setTimeout(function () {
                        $("#auour_loading").hide();
                    }, 500);
                }
                _this._error(xhr, type);
                if (resObj.error && Object.prototype.toString.call(resObj.error) === '[object Function]')
                    resObj.error.apply(resObj.ctx, [xhr, type]);
            }
        });
    },
    /**
     * 七牛上传
     * 例子site.qiNiuUpload('i_file','/QN/admin',callback);
     function callback (res){
	    }
     * html代码 <label for="i_file">
     <span>sb</span>
     </label>
     * 插件'/test':[paglins.plupload,paglins.qiNiu],
     * */
    qiNiuUpload: function (id, path, callback) {
        var _this = this;
        _this.getQiNiuToken();
        var token = _this.getLocal('qiNiuToken');
        $("[name='token']").val(token);
        var html = '<form method="post" name="' + id + '" class="hide" enctype="multipart/form-data">' +
            ' <input name="key" type="hidden" value=""> ' +
            '<input name="token" type="hidden" value=""> ' +
            '<input id="' + id + '" name="file" type="file" accept="image/jpeg" capture="camera"/> ' +
            '</form>'
        if ($("qiNiuUpload").length == 0) {
            $('body').append(html);
        }
        $("#" + id).change(function () {
            var name = $(event.currentTarget).val().split('\\').pop();
            var hash = parseInt(Math.random() * 100000000).toString();
            $("[name='key']").val(path + '/' + hash + name);
            $("[name='token']").val(token);
            var _this = this;
            setTimeout(function () {
                var datas = new FormData(document.forms.namedItem(id))
                $.ajax({
                    type: 'POST',
                    url: 'http://upload.qiniu.com/',
                    data: datas,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        var map = data.key + '?var=' + data.hash;

                        callback.apply(_this, [{url: map, code: 1}])
                    },
                    error: function (xhr, type) {
                        callback.apply(_this, [{url: '', code: 0}]);
                    }
                });
            }, 200);

        });
    },

    /**
     * 七牛上传
     * */
    getQiNiuToken: function () {
        var _this = this;
        var time = new Date().getTime();
        if (_this.getLocal('qiNiuTime') < time) {
            _this._post(_this.javaHttp + '/image/token', {}, this, function (data) {
                _this.getLocal({
                    qiNiuToken: data.result.token,
                    qiNiuTime: time + data.result.expires,
                });
            });
        }
    },

    /**
     * 设置默认参数
     * @data 原参数对象
     * */
    requestJson: function (data) {
        var dataCom = {
            appVer: '1.9.0',
            channelId: 3000001,
            platType: 3,
            activitySource: localStorage.getItem('activitySource'),
            activeId: localStorage.getItem('activeId') || 0,
        };
        var cookString = this.getLocal('cookString');
        if (cookString) {
            dataCom.cookString = cookString;
        }
        var request = $.extend({}, dataCom, data);
        return request;
    },
    /**
     * 获取localStorage
     * */
    getLocal: function () {
        var arg = arguments;
        var _this = this;
        var platTypeQ = this.QueryString('platType');
        platTypeQ = platTypeQ ? platTypeQ : _this.getCookie("platType");

        if (localStorage && !platTypeQ) {

            if (typeof arg[0] == 'string' && !arg[1]) {
                var _res = localStorage.getItem(arg[0]) ? _this.deEight(localStorage.getItem(arg[0])) : localStorage.getItem(arg[0])
                return typeof _res == 'string' ? _res.replace(/"/g, '') : _res;
            } else if (arg[1] !== undefined) {
                localStorage.setItem(arg[0], _this.enEight(arg[1]));
            }
            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
                for (var i in arg[0]) {
                    localStorage.setItem(i, _this.enEight(arg[0][i]));
                }
            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
                var arr = []
                for (var j = 0; j < arg[0]; j++) {
                    arr.push(_this.deEight(localStorage.getItem(j)));
                }
            }
        } else {
            if (arg[0] && typeof arg[0] == 'string' && arg[1] == undefined) {
                return _this.getCookie(arg[0]);
            } else if (arg[1]) {
                _this.setCookie(arg[0], arg[1]);
            }
            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
                for (var i in arg[0]) {
                    _this.setCookie(i, arg[0][i]);
                }
            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
                var arr = []
                for (var j = 0; j < arg[0]; j++) {
                    arr.push(_this.getCookie(j));
                }
            }
        }
    },

    /**
     * 获取sessionStorage
     * */
    getSession: function () {
        var arg = arguments;
        var _this = this;
        var platTypeQ = this.QueryString('platType');
        platTypeQ = platTypeQ ? platTypeQ : _this.getCookie("platType");
        if (localStorage && !platTypeQ) {
            if (typeof arg[0] == 'string' && arg[1] == undefined) {
                return _this.deEight(sessionStorage.getItem(arg[0]));
            } else if (arg[1] != undefined) {
                sessionStorage.setItem(arg[0], _this.enEight(arg[1]));
            }
            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
                for (var i in arg[0]) {
                    sessionStorage.setItem(i, _this.enEight(arg[0][i]));
                }
            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
                var arr = []
                for (var j = 0; j < arg[0]; j++) {
                    arr.push(_this.deEight(sessionStorage.getItem(j)));
                }
            }
        } else {
            if (typeof arg[0] == 'string' && arg[1] == undefined) {
                return _this.getCookie(arg[0]);
            } else if (arg[1] != undefined) {
                _this.setCookie(arg[0], arg[1]);
            }
            if (Object.prototype.toString.call(arg[0]) == '[object Object]' && !arg[1]) {
                for (var i in arg[0]) {
                    _this.setCookie(i, arg[0][i]);
                }
            } else if (Object.prototype.toString.call(arg[0]) == '[object Array]' && !arg[1]) {
                var arr = []
                for (var j = 0; j < arg[0]; j++) {
                    arr.push(_this.getCookie(j));
                }
            }
        }
    },
    getCookie: function (name) { //匹配字段
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"), res, r;
        if (arr = document.cookie.match(reg)) {
            r = decodeURIComponent(arr[2]);
            if (this.isJSON(r)) {
                res = JSON.parse(decodeURIComponent(arr[2]));
            }
        } else {
        }
        return res ? res : r;

    },
    isJSON: function (str) {
        if (typeof str == 'string') {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                console.log(e);
                return false;
            }
        }
    },
    setCookie: function (name, value) {
        //定义一天
        var days = 1;
        var exp = new Date();
        //定义的失效时间，
        exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
        if (Object.prototype.toString.call(value) == '[object Object]') {
            value = JSON.stringify(value);
        }
        //写入Cookie  ，toGMTstring将时间转换成字符串。
        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString();
    },
    /**
     * 8进制解密
     * @txt 8进制对象
     * */
    deEight: function (txt) {
        if (typeof txt == 'number' || (typeof txt == 'string') && txt.indexOf('\\') < 0) {
            return txt;
        }
        if (txt) {
            var monyer = new Array();
            var i;
            var s = txt.split("\\");
            for (i = 1; i < s.length; i++) {
                monyer += String.fromCharCode(parseInt(s[i], 8));
            }
            if (monyer)
                return JSON.parse(monyer);
        }
        return "";
    },

    /**
     * 8进制解密
     * @txt 字符串对象
     * */
    enEight: function (txt) {
        if (txt) {
            txt = JSON.stringify(txt)
            var monyer = new Array();
            var i;
            for (i = 0; i < txt.length; i++)
                monyer += "\\" + txt.charCodeAt(i).toString(8);
            return monyer;
        }
        return "";
    },

    /**
     * 判断传输类型
     * */
    setArguments: function (type, obj) {
        var resObj = obj;
        resObj.async = resObj.async ? true : false;
        return resObj;
    },

    /**
     * ajax错误处理
     * */
    _error: function (xhr, type) {
        var behavior = JSON.parse(xhr.responseText).behavior;
        if (behavior.type == "TOAST") {
            this.showToast(behavior.content);
        } else {
            this.showToastKeep(behavior.content);
        }
    },

    /**
     * 判断是否是函数方法
     * */
    _checkFun: function (fun) {
        return fun && Object.prototype.toString.call(fun) === '[object Function]';
    },

    /**
     * 传输数据加密
     * */
    _encode: function (keyStr, params) {
        var _this = this,
            JSONObject, //加密前json字符串
            key, //密钥
            EncryptStr, //aes加密
            md5Str, //md5加密
            data; //加密后数据
        JSONObject = typeof params == 'string' ? _this._parse_parameter(params) : JSON.stringify(params);
        key = (keyStr + _this.aesKey).substring(0, 16);
        EncryptStr = aesEncrypt(JSONObject, key, _this.ivStr);
        md5Str = CryptoJS.MD5(EncryptStr).toString().toUpperCase();
        data = {encodeString: EncryptStr, md5: md5Str, platType: 3};
        return data;
    },

    /**
     * 将parameter字符串转化为json格式字符串
     * */
    _parse_parameter: function (str) {
        return "{'" + str.replace(/=/g, "':'").replace(/&/g, "','") + "'}";
    },

    /**
     * 将json数据对象整合为字段
     * */
    combiningStr: function (data) {
        var h = ""
        if (data && typeof data == 'object')
            for (var i in data) {
                h += i;
            }
        return h;
    },

    /**
     * 截取url参数search
     * @key 参数键值
     * */
    QueryString: function (key) {
        var uri = decodeURIComponent(window.location.search);
        var re = new RegExp("[\&\?]" + key + "\=([^\&]*)", "ig");
        return ((uri.match(re)) ? (uri.match(re)[0].substr(key.length + 2)) : null);
    },

    /**
     * 截取url参数hash
     * @key 参数键值
     * */
    Queryhash: function (key) {
        var uri = decodeURIComponent(window.location.hash);
        var re = new RegExp("[\&\?]" + key + "\=([^\&]*)", "ig");
        return ((uri.match(re)) ? (uri.match(re)[0].substr(key.length + 2)) : null);
    },

    /**
     * template模板化
     * @id template的id
     * */
    setTpl: function (id) {
        var tpl = _.template($("#" + id).html());
        $("#" + id).remove();
        return tpl;
    },

    /**
     * 判断是否登录
     * */
    isLogin: function () {
        var uid = this.getLocal('uid') && this.getLocal('uid') != undefined && this.getLocal('uid') != 'undefined' && this.getLocal('uid') != null && this.getLocal('uid') != 'null' ? this.getLocal('uid') : '';
        var userData = site.getLocal('userData')
        if ((!uid) || (!userData)) {
            site.getSession("goUrl", location.href);
            return false;
        } else {
            return true;
        }
    },

    /**
     * 会员权限设置跳转
     * */
    loginAndGo: function (url) {
        if (this.isLogin()) {
            window.location.href = url;
        } else {
            window.location.href = 'login.html';
        }
    },

    /**
     * 设置路径缓存
     * */
    setHistoryUrl: function () {
        var url = window.location.href;
        var historyUrl = this.getLocal('current');
        if (url != historyUrl) {
            this.getLocal('referer', historyUrl);
            this.getLocal('current', url);
        }
    },

    /**
     * 输入捆绑删除
     * @data form表单输入框的data-input
     * */
    inputBindDelete: function (data) {
        var input = $("[data-input=" + data + "]");
        var _this = this;
        input.off("focus", _this.toggleInputDelete).on("focus", {status: true, ctx: _this}, _this.toggleInputDelete);
    },

    /**
     * 密码捆绑查看
     * @data form表单输入框的data-input
     * */
    passWordBindSee: function (data) {
        var passWord = $("[data-input=" + data + "]");
        var html = '<i class="icon-see"></i>';
        var icon = '<span class="icon-box"></span>';
        if (passWord.siblings('.icon-box').length == 0) {
            passWord.after(icon)
        }
        passWord.siblings('.icon-box').prepend(html);
        var passWordBtn = $(".icon-see");
        var _this = this;
        passWordBtn.off("click", _this.passWordSee).on("click", _this.passWordSee);
    },

    /**
     * 密码查看
     * */
    passWordSee: function (e) {
        var input = $(e.currentTarget).prev();
        $(e.currentTarget).toggleClass("all");
        var type = input.attr('type') == 'password' ? 'text' : 'password';
        input.attr('type', type);
    },

    /**
     * input删除按钮显示
     * */
    toggleInputDelete: function (e) {
        var html = '<i class="icon-del"></i>';
        var icon = '<span class="icon-box"></span>';
        if ($(e.currentTarget).siblings('.icon-box').length == 0) {
            $(e.currentTarget).after(icon);
        }
        if (e.data.status) {
            if ($(e.currentTarget).siblings('.icon-box').children().eq(0).attr('class') != 'icon-del') {
                $(e.currentTarget).siblings('.icon-box').prepend(html);
                $(".icon-del").on('click', e.data.ctx.inputDelete);
            }
        }
    },

    /**
     * 表单校验
     * @data form表单输入框的data-require
     * @callback 报错回调执行
     * @param 报错回调执行参数
     * 例子:<input type="password" data-require="true" data-pattern="/^.{4,8}$/" data-name="密码" data-alert="重复" data-input="password" style="margin-bottom: 100px">
     * <input type="text" data-input="del" style="margin-bottom: 100px">
     * site.passWordBindSee("password");
     * site.inputBindDelete("del");
     * site.inputClear();
     *
     * */
    formCheck: function (callback, param) {
        var input = $("[data-require]");
        var _this = this;
        for (var i = 0; i < input.length; i++) {
            var obj = input.eq(i);
            var status = _this.inputCheck(obj, callback, param);
            if (!status)
                return false;
        }
        return true;
    },

    /**
     * 单个input验证
     * @obj 当前input节点
     * @callback 当前input节点,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
     * @param 报错回调执行参数
     * */
    inputCheck: function (obj, callback, param) {
        var val = obj.val();
        var name = obj.data('name') ? obj.data('name') : obj.prev('label').text();
        if (val.replace(/\s*/g, "") == '' && obj.data('require') == true) {
            this.error(name + '不能为空', callback, param, obj);
            return false
        }
        var pattern = obj.data("pattern");
        var msg = obj.data("alert") ? obj.data("alert") : name + '格式不正确';
        if (pattern && val) {
            var reg = eval(pattern);
            if (!reg.test(val)) {
                this.error(msg, callback, param, obj);
                return false;
            }
        }
        return true;
    },

    /**
     * 表单判重复
     * @data form表单输入框的data-repeat
     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
     * @param 报错回调执行参数
     * */
    checkRepeat: function (data, callback, param) {
        var input = $("[data-repeat=" + data + "]");
        var _this = this;
        if (input.eq(0).val() != input.eq(1).val()) {
            _this.error('两次密码不一致', callback, param, input.eq(1));
            return false;
        }
    },

    /**
     * 回调报错
     * @msg 默认报错字段
     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
     * @param 报错回调执行参数
     * @obj 报错指向的input节点
     * */
    error: function (msg, callback, param, obj) {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
            callback.apply(this, [param, obj]);
        } else {
            toast.showToast(msg);
        }
    },

    /**
     * 本节点的上一个input节点内容删除
     * */
    inputDelete: function (e) {
        $(e.currentTarget).prev().val("");
    },

    /**
     * input清除按钮
     * @callback 报错回调执行,回调参数param(传入的参数),obj(报错指向的节点),例:function(param,obj){}
     * @param 报错回调执行参数
     * */
    inputClear: function (callback, param) {
        $("input").on('focus', function (e) {
            if ($(e.currentTarget).next().attr('class') != 'icon-del') {
                $(".icon-del").remove();
            }
            if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
                callback.apply(this, [param, $(e.currentTarget)]);
            }
        });
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
            callback.apply(this, [param]);
        }
    },
    /**
     * 获取时间年月日
     * @time 时间戳或者标准时间格式'2017/1/1'
     * */
    getTime: function (time) {
        var t = typeof time == 'number' ? time : time.replace(/-/g, '/');
        var _time = "",
            obj_time = {};
        if (typeof time == 'number') {
            _time = new Date(parseInt(t));
        } else {
            _time = new Date(t);
        }
        obj_time.year = _time.getFullYear();
        obj_time.month = _time.getMonth() + 1;
        obj_time.day = _time.getDate();
        obj_time.hour = _time.getHours();
        obj_time.time = _time.getTime();
        return obj_time;

    },
    /**
     * 获取预定详细时间年月日
     * */
    getTimeDetail: function (start, end) {
        var startTime = start ? start : site.getSession("startMonth");
        var endTime = end ? end : site.getSession("endMonth");
        var day = (new Date(endTime).getTime() - new Date(startTime).getTime()) / 86400000;
        var days = day ? day : site.getSession("allday");
        var time = {
            startTime: site.getTime(startTime ? startTime : new Date().getTime()),
            endTime: site.getTime(endTime ? endTime : new Date().getTime() + 86400000),
            allDay: days ? days : 1,
        };
        return time;
    },
    /**
     * 时间去0,加0
     * */
    exchangeTime: function (time, b) {
        var t = time.split('-');
        if (b) {
            return parseInt(t[0]) + '-' + parseInt(t[1]) + '-' + parseInt(t[2])
        } else {
            return t[0] + '-' + (t[1] < 10 ? '0' + parseInt(t[1]) : t[1]) + '-' + (t[2] < 10 ? '0' + parseInt(t[2]) : t[2])
        }
    },

    /**
     * 时间戳转时间
     * */
    parseTime: function (num) {
        var _time = new Date(parseInt(time));
        return _time.getFullYear() + '-' + (_time.getMonth() + 1) + '-' + _time.getDate();
    },

    /**
     * 执行跳转
     * */
    goUrl: function (url) {
        location.href = url;
    },

    /**
     * 字符串转json
     * */
    strToObj: function (str) {
        var obj = {};
        str = str.serialize();
        str = str.replace(/&/g, "','");
        str = str.replace(/=/g, "':'");
        if (str) {
            str = decodeURIComponent("({'" + str + "'})");
            obj = eval(str);
        }
        return obj;
    },

    /**
     * 阿拉伯数字转换成中文数字
     * */
    translateNumber: function (numberText) {
        numberText = numberText.toString();
        var CHINESE_NEGATIVE = "负";
        var CHINESE_ZERO = "零";
        var CHINESE_DIGITS = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        var CHINESE_GROUP_UNITS = ["", "十", "百", "千", "万", "亿", "兆", "京", "垓", "杼", "穰", "溝", "澗", "正", "載", "極"];
        var arr = [],
            len1 = 0,
            len2 = 0,
            text1 = "",
            text2 = "";
        var type = numberText.indexOf('.') > 0 ? true : false;
        var result = "";
        if (type) {
            arr = numberText.split('.');
            text1 = arr[0];
            text2 = arr[1];
            len1 = text1.length;
            len2 = text2.length;
        } else {
            len1 = numberText.length
            text1 = numberText;
        }
        if (numberText.substr(0, 1) == '-') {
            result += CHINESE_NEGATIVE;
            len1 -= 1;
            text1 = text1.replace('-', "");
        }
        for (var i = 0; i < len1; i++) {
            result += CHINESE_DIGITS[text1[i]] + CHINESE_GROUP_UNITS[len1 - i - 1];
        }
        if (type) {
            if (result == "") {
                result += CHINESE_ZERO;
            }
            result += CHINESE_ZERO;
        }
        for (var j = 0; j < len2; j++) {
            result += (text2[j] == 0 ? CHINESE_ZERO : CHINESE_DIGITS[text2[j]]);
        }
        return result;
    },

    myScroll: function () {

    },
    /**
     * 加载更多
     * */
    loadMore: function (callback, param, b, s) {
        var win = b ? $(b) : $(window);
        win.scroll(function () {
            var box = s ? $(s) : $('body');
            if (win.scrollTop() > (box.height() - 40 - win.height())) {
                $('.pullUpLabel').html('加载中...');
                callback.apply(this, [param]);
                setTimeout(function () {
                    $('.pullUpLabel').html('查看更多');
                }, 1000);
            }
        });
    },

    /**
     * 判断数组内存在元素
     * */
    contains: function (arr, obj) {
        var i = arr ? arr.length : null;
        if (i) {
            while (i--) {
                if (arr[i] === obj) {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * 获取所有的session并且拼接
     * */
    parsePrameter: function () {
        var res = "";
        for (var i in sessionStorage) {
            res += '&' + i + '=' + sessionStorage[i];
        }
        res = res.replace('&', '/?');
        location.hash = res;
    },

    /**
     * 获取所有的search并且存储
     * */
    parseSession: function () {
        var res, arr = [];
        if (location.hash.indexOf('#/?') > -1) {
            res = location.hash.split('#/?')[1];
            arr = res.split('&');
        }
        var _this = this;
        for (var i = 0; i < arr.length; i++) {
            var k = arr[i].indexOf('=') > 0 ? arr[i].split('=') : null;
            if (k) {
                sessionStorage.setItem(k[0], k[1]);
            }
        }
    },

    /**
     * 渲染头部
     * @data {title:'',left:'',right:'',mid:'',}
     * @type 模板
     * */
    renderHeader: function (data, type) {
        var platTypeQ = this.QueryString('platType');
        if (platTypeQ) {
            this.getSession("platType", platTypeQ);
            $("body").css("margin-top", "-48px");
            return false;
        } else if (this.getCookie('platType')) {
            $("body").css("margin-top", "-48px");
            return false;
        }
        var tpl = [];
        var home = "'home.html'";
        var center = "'loginUserCenter.html'";
        tpl[0] = '<header class="header-box clearfix white-bg" data-header = "1"> ' +
            '<p class="header-left-box" onclick="site.goUrl(' + home + ')"> ' +
            '<img src="app/image/history/home_d@2x.png"/><span>首页</span> </p>' +
            ' <p class="header-right-box" onclick="site.goUrl(' + center + ')">' +
            ' <img src="app/image/history/me_d@2x.png"/><span>我的</span> </p> ' +
            '<p class="text-center header-title"></p> </header>'

        tpl[1] = '<div class="header-com" data-header="1">' +
            '<p class="header-return-img"></p> ' +
            '<div class="header-mid-text"><span><%=data.title%></span></div> ' +
            '</div>'

        var i = $("#i_header").data('map') ? $("#i_header").data('map') : 0;
        var map = [{
            hotel: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/home_d.png",
            center: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/me_s.png",
        },
            {
                hotel: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/home_s.png",
                center: "http://h5.at-our.yaduo.com/weixin/image/personalCenter/me_d.png",
            }
        ];
        tpl[2] = '<header class="header-pcHeader"> ' +
            '<div class="header-content"><p class="header-pcImg"></p> ' +
            '<div class="header-mid-text"><span>' +
            (data.title ? data.title : '') + '</span></div> ' +
            (data.icon ? data.icon : '') +
            '</div> <div class="header-pcDropDown"><div class="box"> ' +
            '<a href="home.html" class="header-pcDropBox hotel cell-bl-1"> ' +
            '<img src="' + map[i].hotel + '" /> ' +
            '<p class="fs14">首页</p> ' +
            '</a> ' +
            '<a href="loginUserCenter.html" class="header-pcDropBox center cell-bl-1"> ' +
            '<img src="' + map[i].center + '" /> ' +
            '<p>我的</p> ' +
            '</a> ' +
            '</div>' +
            '</header>';

        var headerTplFun = _.template(tpl[type]);
        var header = $("#i_header");
        header.html(headerTplFun({data: data}));
        $("title").text($(".header-mid-text").text());
        $(".header-return-img").off().on('click', function () {
            if (data.left && Object.prototype.toString.call(data.left) === '[object Function]') {
                data.left.apply();
            } else {
                history.back();
            }
        });
        $(".header-mid-text").off().on('click', function () {
            if (data.mid && Object.prototype.toString.call(data.mid) === '[object Function]') {
                data.mid.apply();
            }
        });
        $(".header-pcImg").off().on('click', function () {
            $(event.currentTarget).toggleClass('on');
            $(".header-pcDropDown").toggleClass('all');
        });
    }, /**
     * 是否在微信
     * */
    isWeiXin: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 微信分享
     * imgUrl: data.imgUrl, // 分享图标
     * title: data.title, // 分享标题
     * dec: data.desc, // 分享描述
     * link: data.link, // 分享链接
     * cancel: data.cancel, // 分享取消
     * {imgUrl:imgUrl,title:title,dec:desc,link:link,cancel:cancel}
     **/
    weixinSdkConfig: function (datas) {
        var title = "亚朵生活"; // 分享标题
        if (datas.title) title = datas.title;
        var dec = document.title;
        if (datas.dec) dec = datas.dec;
        var share_url = window.location.href; // 分享链接
        if (datas.link) share_url = datas.link;
        var imgUrl = "http://on3q6c8d9.bkt.clouddn.com/logo.png"; // 分享图标
        if (datas.imgUrl) imgUrl = datas.imgUrl;
        $(document).ready(function () {
            if (site.isWeiXin()) {
                wx.ready(function () {

                    // 2. 分享接口
                    // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareAppMessage({
                        title: title,
                        desc: dec,
                        link: share_url,
                        imgUrl: imgUrl,
                        trigger: function (res) {
                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回

                        },
                        success: function (res) {
                        },
                        cancel: function (res) {

                        },
                        fail: function (res) {
                            //alert(JSON.stringify(res));
                        }
                    });

                    // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareTimeline({
                        title: title,
                        desc: dec,
                        link: share_url,
                        imgUrl: imgUrl,
                        trigger: function (res) {
                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回

                        },
                        success: function (res) {
                        },
                        cancel: function (res) {

                        },
                        fail: function (res) {
                            //alert(JSON.stringify(res));
                        }
                    });

                    // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareQQ({
                        title: title,
                        desc: dec,
                        link: share_url,
                        imgUrl: imgUrl,
                        trigger: function (res) {
                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回

                        },
                        success: function (res) {

                        },
                        cancel: function (res) {

                        },
                        fail: function (res) {
                            //alert(JSON.stringify(res));
                        }
                    });

                    // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareWeibo({
                        title: title,
                        desc: dec,
                        link: share_url,
                        imgUrl: imgUrl,
                        trigger: function (res) {
                            // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回

                        },
                        success: function (res) {
                        },
                        cancel: function (res) {

                        },
                        fail: function (res) {
                            //alert(JSON.stringify(res));
                        }
                    });
                });
            } else {
                site.share()
                var $config = {
                    url: share_url, // 网址，默认使用 window.location.href
                    source: title, // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
                    title: title, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: dec, // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: imgUrl, // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat'], // 启用的站点
                    disabled: ['google', 'facebook', 'twitter'], // 禁用的站点
                    wechatQrcodeTitle: "扫一扫：分享", // 微信二维码提示文字
                    wechatQrcodeHelper: '<p>' + dec + '</p>',
                };
                $('#yd-share').share($config);
            }
        });
    },
    /**
     * 获取微信token,
     * 设置微信config
     * @apiList 需要调用的微信api
     * @callback 设置完成回调
     * @param 回调参数
     * */
    getWxToken: function (apiList, callback, param) {
        var puurl = encodeURIComponent(location.href.split('#')[0]); //
        var url = "http://www.yaduo.com:9300/api/meb/ActMebDayByGetWechatConfig?pageUrl=" + puurl;
        $.ajax({
            url: url,
            dataType: "json",
            cache: true,
            type: 'GET',
            success: function (data) {
                var cofigData = data.Data;
                var config = {
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: cofigData.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
                    timestamp: cofigData.TimeStamp, //必填，生成签名的时间戳
                    nonceStr: cofigData.NonceStr, // 必填，生成签名的随机串
                    signature: cofigData.Signature, // 必填，签名，见附录1
                    jsApiList: apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                } //startRecord开始录音接口，startRecord识别音频并返回识别结果接口，stopRecord停止录音接口，playVoice播放语音接口
                $(document).ready(function () {
                    wx.config(config);
                    wx.error(function (res) {
                    });
                    if (callback && Object.prototype.toString.call(callback) === '[object Function]')
                        callback.apply(this, [param]);
                });
            },
            error: function (data) {
            }
        });
    },
    /**
     * 分享
     * @success data.success, // 分享成功
     * @callback 记载成功后返回的方法
     * */
    share: function (callback) {
        if (this.isWeiXin()) {
            this.getWxToken([
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo'
            ], callback);
        } else {
            var jia = '<div class="jiathis_style_32x32">' +
                '<p class="share-title">分享</p>' +
                '<p class="share-title" id="yd-share"></p>' +
                '<p class="share-cancle" >取消</p>' +
                '</div> ' +
                '<script type="text/javascript" src="app/js/lib/jquery.share.min.js" charset="utf-8"></script>' +
                '<link rel="stylesheet" href="app/css/lib/share.min.css">'
            $('#i_share').html(jia);
            if (callback && Object.prototype.toString.call(callback) === '[object Function]')
                callback.apply()
        }
    },


    /**
     * 经纬度算距离
     * @param {Object} lat1
     * @param {Object} lng1
     * @param {Object} lat2
     * @param {Object} lng2
     * */
    getGreatCircleDistance: function (lat1, lng1, lat2, lng2) {
        var EARTH_RADIUS = 6378137.0; //单位M
        var PI = Math.PI;

        function getRad(d) {
            return d * PI / 180.0;
        }

        var radLat1 = getRad(lat1);
        var radLat2 = getRad(lat2);

        var a = radLat1 - radLat2;
        var b = getRad(lng1) - getRad(lng2);

        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000.0;
        return (s / 1000).toFixed(2) + "公里";
    },

    /**
     * 获取当前城市经纬度
     * */
    getCity: function () {
        var mapObj = new AMap.Map('container');
        mapObj.plugin(["AMap.CitySearch"], function () {
            //实例化城市查询类
            var citysearch = new AMap.CitySearch();
            //自动获取用户IP，返回当前城市
            citysearch.getLocalCity();
            AMap.event.addListener(citysearch, "complete", function (result) {
                var p = result.rectangle.split(';');
                site.getSession("currentLongitude", p[0].split(',')[0]);
                site.getSession("currentLatitude", p[0].split(',')[1]);
            });
            AMap.event.addListener(citysearch, "error", function (result) {
            });
        });
    },
    /**
     * 获取当前经纬度
     * */
    getUserLocation: function (callback) {
        var map, geolocation;
        $('#auour_loading').show();
        //if(this.isWeiXin()&&wx){
        //    this.getWxToken(['getLocation']);
        //    wx.getLocation({
        //        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        //        success: function (res) {
        //            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
        //            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        //            //var speed = res.speed; // 速度，以米/每秒计
        //            //var accuracy = res.accuracy; // 位置精度
        //            $('#auour_loading').hide();
        //            site.getSession("currentLongitude", longitude);
        //            site.getSession("currentLatitude", latitude);
        //            callback.apply(this, [{success: 1}]);
        //        }
        //    });
        //}else{
        //加载地图，调用浏览器定位服务
        map = new AMap.Map('container', {
            resizeEnable: true
        });
        map.plugin('AMap.Geolocation', function () {
            geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, //是否使用高精度定位，默认:true
                timeout: 3000, //超过10秒后停止定位，默认：无穷大
                buttonOffset: new AMap.Pixel(10, 50), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                buttonPosition: 'RB'
            });
            map.addControl(geolocation);
            geolocation.getCurrentPosition();
            AMap.event.addListener(geolocation, 'complete', onComplete); //返回定位信息
            AMap.event.addListener(geolocation, 'error', onError); //返回定位出错信息
        });

        //解析定位结果
        function onComplete(data) {
            $('#auour_loading').hide();
            site.getSession("currentLongitude", data.position.getLng());
            site.getSession("currentLatitude", data.position.getLat());
            callback.apply(this, [{
                success: 1,
                city: data.addressComponent.province,
                latitude: data.position.getLat(),
                longitude: data.position.getLng()
            }]);
        }

        //解析定位错误信息
        function onError(data) {
            $('#auour_loading').hide();
            toast.showToast('定位失败');
            callback.apply(this, [{error: 1}]);
        }

        //}
    },
    /**
     * 页面跳转定向
     * */
    atourlifeGo: function (h) {
        var arr = [], _href = h;
        if (h.indexOf('atourlife://') > -1) {
            if (h.indexOf('?')) {
                arr = h.split('?');
            } else {
                arr[0] = h;
            }
            var path = {
                hoteldetails: 'http://wechat.yaduo.com/weixin/hotelDetail.html',
                bambooRoom: 'http://wechat.yaduo.com/plugInUnit/BambooRoom/bambooroom.html',
            };
            _href = path[arr[0].split('://')[1]] + (arr[1] ? '?' + arr[1] : '');
        }
        //if (this.isMobile()) {
        //    window.location.href = h;
        //} else {
        window.location.href = _href;
        //}
    },
    /**
     * 判断是否手机打开
     * */
    isMobile: function () {
        var mobileAgent = new Array("iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire");

        var browser = navigator.userAgent.toLowerCase();

        var isMobile = false;

        for (var i = 0; i < mobileAgent.length; i++) {
            if (browser.indexOf(mobileAgent[i]) != -1) {
                isMobile = true;

                break;
            }
        }
        return isMobile;
    },
    /**
     * 获取微信授权
     * */
    getOpenId: function () {
        if ((!site.getLocal('openId')) && site.isWeiXin()) {
            window.location.href = site.javaHttp + 'weixin/login'
        }
    },
    toastCode: {
        toasts: false,
        _toasts: false,
        pages: false,
        dialogs: false,
        _dialogs: false,
        passwords: false,
        others: false,
        content: ''
    },
    toast: function (obj, code, msg) {
        obj.toasts[code] = true
        obj.toasts['content'] = msg
    }
}
window.site = site;



// WEBPACK FOOTER //
// ./src/assets/js/site.js